import React from 'react'
import { Column, Columns, Container } from '@resurs/midas-react'
import { getText } from '../../../internal/TextLabels'

export const PaymentMethodListHeader = () => (
  <Container>
    <div
      style={{
        border: '1px solid rgba(0, 0, 0, 0.12)',
        borderBottom: '2px solid rgba(0, 0, 0, 0.12)',
        paddingLeft: '1rem',
      }}
    >
      <Container>
        <Columns>
          <Column col3>
            <small>
              <b>{getText('paymentSettings.paymentMethods.paymentMethod')}</b>
            </small>
          </Column>
          <Column col5>
            <small>
              <b>
                {getText('paymentSettings.paymentMethods.periodOfValidity')}
              </b>
            </small>
          </Column>
          <Column col2>
            <small>
              <b>{getText('paymentSettings.paymentMethods.fee')}</b>
            </small>
          </Column>
          <Column col2>
            <small>
              <b>{getText('paymentSettings.paymentMethods.dispayOrder')}</b>
            </small>
          </Column>
        </Columns>
      </Container>
    </div>
  </Container>
)
